export const CARD_NAME_IN_LISTING = "CARD_NAME_IN_LISTING";
export const CARD_NAME_IN_COMPARE = "CARD_NAME_IN_COMPARE";